var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1065.902,
    height: 1212.49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 202",
    d: "M762.758 1100.857a73.756 73.756 0 0 1-20.662-2.8c-34.043-9.602-57.145-41.388-57.483-79.12l-.967-108.086c-.598-66.774-50.143-120.667-110.448-120.128s-108.884 55.31-108.286 122.085l.966 108.089c.338 37.732-22.19 69.928-56.051 80.136-31.94 9.609-64.899-3.076-83.947-32.37-65.027-100.007-74.017-177.146-84.424-266.455-2.909-24.981-5.916-50.789-10.299-78.589a399.056 399.056 0 0 1-64.66-179.66c-7.831-75.868-8.27-125.67-8.281-127.753-1.42-158.703 116.14-288.902 262.065-290.208 52.685-.469 103.382 15.892 147.391 47.448 43.435-32.339 93.83-49.606 146.515-50.077 145.927-1.306 265.8 126.768 267.219 285.504.026 2.05.47 51.854-5.994 127.847a399.11 399.11 0 0 1-61.442 180.781c-3.877 27.874-6.42 53.717-8.884 78.749-8.803 89.481-16.406 166.769-79.639 267.938-14.54 23.259-37.816 36.446-62.689 36.669Z",
    fill: "#fefeff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth);
export default __webpack_public_path__ + "static/media/tooth.58cec9ac147ba2b6667b321624c9d2d5.svg";
export { ForwardRef as ReactComponent };